export default __webpack_public_path__ + "static/media/home-shop-classic-04.3274a0d1.png";